import { setGADataLayer, getCreator } from 'analytics'

export function trackGA4NavigationEvent(url, type) {
    const data = {
        event: 'creator_social_nav',
        options: {
            eventInfo: {
                'eventInfo.navElement': 'creator',
                'eventInfo.navSubelement': 'creator social',
                'eventInfo.link': url,
            },
            creator: {
                ...getCreator(),
                socialLink: type,
            },
        },
    }
    setGADataLayer(data)
}
